import { defineStore } from 'pinia'
import { useAuthStore } from '@/stores/user/auth'
import axios from 'axios'
import { getResponse } from '@/composables/api'

export const useRefStore = defineStore({
   id: 'refs',
   state: () => ({
      timezones: null,
      tags: null,

      storeAuth: useAuthStore(),
   }),
   getters: {
       sortedTags: (state) => {
           if (!state.tags) return [];
           return [...state.tags].sort((a, b) => a.name.localeCompare(b.name));
       }
   },
   actions: {
      timezones() {
         axios.get('ref/timezones')
         .then((response) => {
            this.timezones = getResponse(response)
         })
      },
      getTags() {
         axios.get('ref/tags')
         .then((response) => {
            this.tags = getResponse(response)
         })
      },
   }
})